// <tbrb-pick-card> — snippets/tbrb-pick-card.liquid. Loaded once in layout/theme.liquid.
// Keeps price, % badge, hidden variant id and button state in step with the size dropdown.
// Once the selected variant is in the cart the button becomes a − qty + stepper (cart:updated keeps every card in sync).
if (!customElements.get('tbrb-pick-card')) {
  const root = window.Shopify?.routes?.root || '/';

  // One cart snapshot for all cards: filled from cart:updated payloads, cart.js only when none seen yet.
  const pickCart = {
    cart: null,
    req: null,
    get() {
      if (this.cart) return Promise.resolve(this.cart);
      return (this.req ||= fetch(`${root}cart.js`)
        .then((r) => r.json())
        .then((c) => (this.cart = c))
        .finally(() => { this.req = null; }));
    },
  };

  customElements.define('tbrb-pick-card', class extends HTMLElement {
    connectedCallback() {
      this.ctrl = new AbortController();
      const { signal } = this.ctrl;
      this.addEventListener('change', (e) => this.onSelect(e), { signal });
      this.addEventListener('click', (e) => this.onStep(e), { signal });
      document.documentElement.addEventListener('cart:updated', (e) => {
        if (!e.detail?.cart) return;
        pickCart.cart = e.detail.cart;
        this.sync(e.detail.cart);
      }, { signal });
      // client-rendered cards (Wizzy search) can't know the cart server-side: read it on connect
      if (this.hasAttribute('data-pick-sync')) pickCart.get().then((cart) => this.sync(cart)).catch(() => {});
    }

    disconnectedCallback() {
      this.ctrl?.abort();
    }

    get variantId() {
      return Number(this.querySelector('[data-pick-id]').value);
    }

    onSelect(e) {
      const select = e.target.closest('[data-pick-select]');
      if (!select) return;
      const opt = select.selectedOptions[0];
      const badge = this.querySelector('[data-pick-badge]');
      const btn = this.querySelector('[data-pick-atc]');
      const soldOut = opt.hasAttribute('data-soldout');
      this.querySelector('[data-pick-price]').textContent = opt.dataset.money;
      const compare = this.querySelector('[data-pick-compare]');
      if (compare) {
        compare.textContent = opt.dataset.compare;
        compare.hidden = !opt.dataset.compare;
      }
      this.querySelector('[data-pick-id]').value = opt.value;
      if (badge) {
        const pct = Number(opt.dataset.pct);
        badge.hidden = pct < 1;
        badge.querySelector('[data-pick-pct]').textContent = pct + '%';
      }
      btn.disabled = soldOut;
      // loader-button wraps the label in .loader-button__text next to its spinner; only swap the label
      (btn.querySelector('.loader-button__text') || btn).textContent = soldOut ? btn.dataset.soldOut : btn.dataset.label;
      pickCart.get().then((cart) => this.sync(cart)).catch(() => {});
    }

    // Show the stepper with the cart qty of the selected variant (all its lines), or the button when 0.
    sync(cart) {
      const qty = cart.items
        .filter((item) => item.variant_id === this.variantId)
        .reduce((sum, item) => sum + item.quantity, 0);
      this.querySelector('[data-pick-atc]').hidden = qty > 0;
      this.querySelector('[data-pick-qty]').hidden = qty < 1;
      this.querySelector('[data-pick-count]').textContent = qty;
    }

    async onStep(e) {
      const step = e.target.closest('[data-pick-step]');
      if (!step) return;
      const box = this.querySelector('[data-pick-qty]');
      box.setAttribute('aria-busy', 'true');
      try {
        const cart = await pickCart.get();
        const line = cart.items.filter((item) => item.variant_id === this.variantId).pop();
        if (!line) return this.sync(cart);
        const res = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity + Number(step.dataset.pickStep) }),
        });
        if (!res.ok) {
          // stale snapshot (line key gone): drop it and show the real cart
          pickCart.cart = null;
          return this.sync(await pickCart.get());
        }
        // drawer picks this write up through its cart watcher; this event syncs the cards + other listeners
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: await res.json() } }));
      } catch (err) {
        console.error(err);
      } finally {
        box.removeAttribute('aria-busy');
      }
    }
  });
}
